/**
 * Checks if Hx is globally available in the current window.
 */
function isHx(): boolean {
    return window.HxGlobals !== undefined;
}

/**
 * Checks if we are running inside the
 * Microsoft Webview2 browser host
 *
 * See https://docs.microsoft.com/en-us/microsoft-edge/webview2
 */
function isWebView2(): boolean {
    // TODO (#88367) check with the webview2 team what
    // the best way to identify if we are in webview2 is
    return window.chrome?.webview !== undefined;
}

/**
 * Checks if we are running in the One Outlook Host
 */
export function isOneOutlookHost(): boolean {
    return isHx() && isWebView2();
}
